import apiService from './apiService';

/**
 * Ecommerce Settings Service
 * Fetches public store settings from the backend.
 * No auth required — these are read-only public configuration values.
 */
class SettingsService {
    /**
     * Fetch public store settings (e.g. cash_discount_percent).
     * Expected response shape from backend:
     *   { success: true, data: { settings: { cash_discount_percent: 5, ... } } }
     *
     * @returns {Promise<object>} Settings object
     */
    async getPublicSettings() {
        const response = await apiService.get('/ecommerce/settings');
        // Support both { data: { settings: {...} } } and { data: { cash_discount_percent: ... } }
        return response?.data?.settings ?? response?.data ?? {};
    }
}

const settingsService = new SettingsService();
export default settingsService;
